import { defineComponent as _defineComponent } from 'vue'
import 'jquery-validation';

import $ from 'jquery';
import {
    computed,
    inject,
    nextTick,
    onMounted,
    shallowRef,
    unref,
    watch,
} from 'vue';

import { setupAutofillControl, setupAutoprettifyControls } from '#public/commons-global';
import { useGenerateIds, useJqueryEventListener } from '#public_ts/composables';

import updateDataAttributes from './data-attributes';
import { ValidatorInstance } from './injection';


export default /*#__PURE__*/_defineComponent({
  __name: 'input-control',
  props: {
    id: null,
    name: null,
    value: null,
    booleanValue: { type: Boolean },
    type: null,
    data: null
  },
  emits: ["input", "update:booleanValue"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: string): void;
    (event: 'update:booleanValue', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    id?: string;
    name?: string;
    value?: string | number;
    //for checkbox and radio
    booleanValue?: boolean;
    type?: string;
    data?: Record<string, unknown>;
}


//eslint-disable-next-line no-spaced-func


const input = shallowRef<HTMLInputElement | undefined>();
const validatorInstance = inject(ValidatorInstance, undefined);
const generateIds = useGenerateIds();
const controlId = props.id || generateIds();
const controlName = props.name || controlId;
const isCheckbox = computed(() => (props.type == 'checkbox') || (props.type == 'radio'));

function setupValidator() {
    const _input = unref(input);
    const _validatorInstance = unref(validatorInstance);
    if(_input && _validatorInstance) {
        const rules: JQueryValidation.RulesDictionary | undefined = $(_input).rules();
        if(rules && Object.keys(rules).length) {
            setupAutofillControl($(_input), rules, _validatorInstance);
        }
    }
}

if(validatorInstance) {
    watch(validatorInstance, setupValidator, { immediate: true });
}

watch(() => props.data, (val) => {
    const _input = unref(input);
    if(_input && val) {
        updateDataAttributes($(_input), val);
    }
}, { deep: true });

onMounted(() => {
    const _input = unref(input);
    if(_input) {
        if(props.data) {
            updateDataAttributes($(_input), props.data);
        }
        setupAutoprettifyControls($(_input));
        setupValidator();
    }
});

function onInput(e: Event) {
    if(unref(isCheckbox)) {
        emit('update:booleanValue', $(e.target as HTMLInputElement)?.is(':checked'));
    } else {
        emit('input', (e.target as HTMLInputElement)?.value);
    }
}

//autoformat support
//because autoformat uses jquery events, we need also
useJqueryEventListener(input, 'blur autoformat', () => {
    if(unref(isCheckbox)) {
        return;
    }
    nextTick(() => {
        const _input = unref(input);
        if(_input) {
            const val = $(_input).val();
            if((val !== undefined) && (typeof (val) === 'string') && (val !== props.value)) {
                emit('input', val);
            }
        }
    });
});

return { __sfc: true,props, emit, input, validatorInstance, generateIds, controlId, controlName, isCheckbox, setupValidator, onInput }
}

})